





























import { Component, Vue } from "vue-property-decorator";
@Component({
  name: "webgl-context-lost-modal",
})
export default class WebGLContextLostModal extends Vue {
  get active(): boolean {
    return this.$store.getters["SystemStore/getShowWebGLContextLostModal"];
  }
  set active(e: boolean) {
    this.$store.dispatch("SystemStore/setShowWebGLContextLostModalAction", e);
  }

  backToNubii() {
    location.reload();
  }
}
